// extracted by mini-css-extract-plugin
export default {"appWrapper":"TermsOfServicePage_appWrapper__xX9u0"};